<template>
  <header class="subHeader">
    <div class="content-header">USER MANAGEMENT</div>
    <div class="content-body">
      <a> Add users to the event planner tool and edit accounts.</a>
    </div>
    <div class="group-button-sub-header">
        <SubHeaderButton class="float-right" :item="btnAddUser"> </SubHeaderButton>
      </div>
  </header>
</template>
<script>
import SubHeaderButton from './SubHeaderButton';
import consts from '../../_consts';

export default {
  name: 'subHeaderUserManagement',
  methods: {
    sidebarToggle (e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    }
  },
  components: {
    SubHeaderButton
  },
  data () {
    return {
      btnAddUser: consts.subHeaderBtn.addUser
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.subHeader{
  margin-top: 3px;
}
.group-button-sub-header{
  float: right;
  top: 120px;
  margin: 65px 30px 0 0;
}

.content-header{
  width: 250px;
}

.float-left{
  float: left;
}

.float-right{
  float: right;
}
</style>



// WEBPACK FOOTER //
// SubHeaderUserManagement.vue?0a2a7b08